import { Box } from '@mui/material'
import TagInput from '../../../../../shared/components/inputs/TagInput'

interface OffersTagsCellProps {
  params: any
}

const OffersTagsCell = ({ params }: OffersTagsCellProps) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
      <TagInput rowId={params.row.id} rowTags={params.row.tags} rowCountries={params.row.countries} rowBrandId={params.row.brand_id} page={'offers'} />
    </Box>
  )
}

export default OffersTagsCell
